import { useEffect, useRef } from "react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useNotifications } from "@/modules/notifications";
import type { Notification } from "@/modules/notifications/types";

const SESSION_KEY = "safecheck-enterprise-dashboard-alerts-seeded";

/**
 * Place les alertes entreprise dans la cloche (pas en toasts flottants).
 */
export function useEnterpriseDashboardAlerts() {
  const { t } = useTranslation();
  const { upsertLocal } = useNotifications();
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current) return;
    if (typeof window !== "undefined" && sessionStorage.getItem(SESSION_KEY) === "1") {
      seeded.current = true;
      return;
    }
    seeded.current = true;

    const alerts = t.safecheck.dashboard.enterpriseAlerts;
    const now = Date.now();
    const items: Notification[] = [
      {
        id: "enterprise-alert-invoice-validated",
        type: "invoice",
        itemKey: "invoiceApproved",
        read: false,
        createdAt: now - 60_000,
        href: "/dashboard/invoices/approved",
        title: alerts.invoiceValidated.title,
        message: alerts.invoiceValidated.message,
      },
      {
        id: "enterprise-alert-budget-cumulative",
        type: "system",
        itemKey: "systemBackupComplete",
        read: false,
        createdAt: now - 120_000,
        href: "/dashboard/enterprise",
        title: alerts.budgetCumulative.title,
        message: alerts.budgetCumulative.message,
      },
      {
        id: "enterprise-alert-budget-out-of-package",
        type: "system",
        itemKey: "systemBackupComplete",
        read: false,
        createdAt: now - 180_000,
        href: "/dashboard/enterprise",
        title: alerts.budgetOutOfPackage.title,
        message: alerts.budgetOutOfPackage.message,
      },
    ];

    upsertLocal(items);
    sessionStorage.setItem(SESSION_KEY, "1");
  }, [t, upsertLocal]);
}
